import ResultTable from './ResultTable';
import ResultTableLeft from './ResultTableLeft';
import ResultTableMiddle from './ResultTableMiddle';
import ResultTableRight from './ResultTableRight';

export { ResultTable, ResultTableMiddle, ResultTableLeft, ResultTableRight };
